export default {
  support: {
    support: 'Soutien',
    requestFeature: 'demander une fonctionnalité',
    reportBug: 'signaler un bug',
    topic: 'Sujet',
    description: 'Description',
    addScreenshot: 'Ajouter une capture d\'écran (facultatif)',
    towOrder: 'Ordre de remorquage',
    dispatch: 'Expédition',
    thankYouForYourFeedback: 'Merci pour votre avis!',
    weAppreciateYourPartnership: 'Nous apprécions votre partenariat',
    couldNotSubmitRequest: 'Malheureusement, nous n\'avons pas pu soumettre votre demande.',
    submit: 'Soumettre'
  },
};
